import { SnackbarOrigin } from "notistack";

export const imageStructure = [
  [
    {
      rows: 10,
      cols: 10,
    },
  ],
  [
    {
      rows: 10,
      cols: 5,
    },
    {
      rows: 10,
      cols: 5,
    },
  ],
  [
    {
      rows: 6,
      cols: 10,
    },
    {
      rows: 4,
      cols: 5,
    },
    {
      rows: 4,
      cols: 5,
    },
  ],
  [
    {
      rows: 6,
      cols: 10,
    },
    {
      rows: 4,
      cols: 3,
    },
    {
      rows: 4,
      cols: 4,
    },
    {
      rows: 4,
      cols: 3,
    },
  ],
  [
    {
      rows: 5,
      cols: 5,
    },
    {
      rows: 5,
      cols: 5,
    },
    {
      rows: 5,
      cols: 3,
    },
    {
      rows: 5,
      cols: 4,
    },
    {
      rows: 5,
      cols: 3,
    },
  ],
];

export const anchorSnackbarTop: SnackbarOrigin | undefined = {
  vertical: "top",
  horizontal: "right",
};

//INFO: Include all the routes where infinite scroll is there and back functionality needs to be restored
export const appConfig = {
  retainTabRoutesWithInfiniteScroll: [
    "/feed/all",
    "/feed/sc",
    "/feed/activity",
  ],
  experienceTabRoutes: ["/experiences/upcoming", "/experiences/archive"],
  learnTabRoutes: ["/learn/courses", "/learn/masterclass"],
};

export const chConfig = {
  retainTabRoutesWithInfiniteScroll: [
    "/joined-clubhouses",
    "/feed/sc",
    "/feed/activity",
  ],
};
